import { create } from "zustand";

interface ToastState {
  current: string | null;
  _timer: number | null;
  show: (msg: string, ms?: number) => void;
  dismiss: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  current: null,
  _timer: null,
  show: (msg, ms = 2400) => {
    const { _timer } = get();
    if (_timer) window.clearTimeout(_timer);
    set({ current: msg });
    const t = window.setTimeout(() => set({ current: null, _timer: null }), ms);
    set({ _timer: t });
  },
  dismiss: () => {
    const { _timer } = get();
    if (_timer) window.clearTimeout(_timer);
    set({ current: null, _timer: null });
  },
}));
